import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Image, Link } from 'components';
import { media } from "utils/media";

const Column = ({ className, content, locale, link }) => {
  let localPrice = null;
  switch(locale) {
    case 'uk':
      localPrice = content.priceUk
      break;
    case 'en':
      localPrice = content.priceEn
      break;
    case 'se':
      localPrice = content.priceSe
      break;
    default:
      localPrice = null;
      break;
  }
  return(<>
    <div className={cx('column', [className])}>
        <div className='section-media'>
          <Image url={media(content.image)} alt={content.title} />
        </div>
        <div className='section-text t-center'>
          <Image url={media(content.icon)} alt='Decorative icon' />
          <h2 className='mt-20 mb-20'>{content.title}</h2>
          <p className='price'>{localPrice}</p>
          <p>{content.copy}</p>
          <Link to={link.path} {...link} className='button outline mt-20'>Learn more</Link>
        </div>
      </div>
  </>)
};

Column.propTypes = {
    className: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired
};

Column.defaultProps = {
    className: '',
    content: {},
    locale: ''
};

export default Column;
